import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


import Draggable from 'react-draggable';
import {
    Button,
    IconButton
} from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import CallEndIcon from '@material-ui/icons/CallEnd';
import clsx from "clsx";
import { svgIcons } from './svgIcons';

const useStyles = makeStyles((theme) => ({
    draggableParent: {
        position: "absolute",
        top: '0',
        left: '0',
        width: "calc(100%)",
        height: "calc(100%)",
        padding: "50px 5px 5px 50px"
    },
    greenButton: {
        backgroundColor: "green",
        "&:hover": {
            backgroundColor: "green !important",
            color: '#000',
        },
    },
    redButton: {
        backgroundColor: "red",
        "&:hover": {
            backgroundColor: "red !important",
            color: '#000',
        },
    },
    draggableWindow: {
        position: "absolute",
        zIndex: "99",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        resize: "both",
        overflow: "auto",
        backgroundColor: "#FAFAFA55",
        backdropFilter: "blur(5px)",
        borderRadius: "5px"
    },
    draggableTop: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "25px",
        justifyContent: "flex-end",
        cursor: "grab",
        color: "white"
    },
    draggableTopHandle: {
        display: "flex",
        flexGrow: "1"
    },
    draggableTopCloseButton: {
        display: "flex"
    },
    windowHeader: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        padding: "10px 5px 5px"
    },
    windowURLInput: {
        display: "flex",
        flexGrow: "1"
    },
    windowButton: {
        display: "flex",
        width: '30px',
        padding: '0',
        color: "white",
        "&:hover": {
            color: "white"
        }
    },
    windowIframeOutput: {
        position: 'absolute',
        display: "flex",
        backgroundColor: "#DCDCDC",
        padding: "0px",
        width: "100%",
        height: "100%"
    },

    verticalEdge: {
        display: "flex",
        width: "2px",
        height: "100%",
        cursor: "n-resize",
    },
    horizontalEdge: {
        display: "flex",
        width: "100%",
        height: "2px",
    }
}));
var pendingCall = false 
export default function PeerConnection(props) {
    const [windowResolution, setWindowResolution] = React.useState({ width: "60vw", height: "65vh" });
    const [windowPosition, setWindowPosition] = React.useState({ x: 40, y: 120 });
    const windowRef = React.createRef(null)
    const classes = useStyles();
    const [call, setCall] = React.useState(null)
    const [openAccept, setOpenAccept] = React.useState(false)

    function gotBall(e, call) {
        setCall(call)
        let video = document.getElementById('videoOut');
        video.srcObject = e;
        video.play()
    }
    async function soundAlarm() {
        var playAudio = true;
        var snd = new Audio("data:audio/wav;base64,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");
        for (var i = 0; i < 3; i++) {
            for (var j = 0; j < 3; j++) {
                try {
                    if (playAudio)
                        await snd.play();
                } catch (err) {
                    playAudio = false
                }
                await new Promise(r => setTimeout(r, 320));
            }
            await new Promise(r => setTimeout(r, 1200));
        }
    }
    React.useEffect(() => {

        if (props.open && props.peer && !pendingCall) {
            pendingCall = true 
            callPeer(props.peer, gotBall)
        }
        if (props.open && props.call && !pendingCall) {
            pendingCall = true 
            setOpenAccept(true)
            soundAlarm()
            setWindowResolution({ width: "20vw", height: "25vh" })
        }
           /* eslint-disable react-hooks/exhaustive-deps  */
    }, [props])
    var displayMediaOptions = {
        video: true,
    }
    function accept() {
        setOpenAccept(false)

        setupCall(props.call, gotBall)
    }

    function setupCall(call, cb) {
        navigator.mediaDevices.getDisplayMedia(displayMediaOptions).then((streamIn) => {
            let [videoTrack] = streamIn.getVideoTracks();
            navigator.mediaDevices.getUserMedia({
                audio: true
            }).then((audioStream) => {
                let [audioTrack] = audioStream.getAudioTracks();
                let stream = new MediaStream([videoTrack, audioTrack]);

                call.answer(stream); // Answer the call with an A/V stream.
                call.on('stream', function (remoteStream) {
                    cb(remoteStream, call)
                    // Show stream in some video/canvas element.
                });
                call.on('close', handleClose)
            })
        }, function (err) {
            console.log('Failed to get local stream', err);
        })
    }

    function callPeer(peerID, cb) {
        navigator.mediaDevices.getUserMedia({
            audio: true,
            video: true,
        }).then((audioStream) => {
            // navigator.mediaDevices.getDisplayMedia({video:true).then((stream)=> {
            let call = props.gPeer.call(peerID, audioStream);
            call.on('stream', function (remoteStream) {
                // Show stream in some video/canvas element.
                cb(remoteStream, call)
            });
            call.on('close', handleClose)
        }, function (err) {
            console.log('Failed to get local stream', err);
        });
    }
    function handleDrag(e, ui) {
        setWindowPosition(prev => {
            return { x: prev.x + ui.deltaX, y: prev.y + ui.deltaY }
        });
    }

    function handleDragStart() {
    }

    function handleDragEnd(e, ui) {

    }

    function handleClose() {
        pendingCall = false
        if (call) call.close()
        if (props.cb) props.cb(null)
    }
    return (
        <div className={classes.draggableParent}>
            <Draggable
                handle="strong"
                onDrag={handleDrag}
                onStart={handleDragStart}
                onStop={handleDragEnd}
                position={windowPosition}
                defaultClassName="draggable-piano"
                defaultClassNameDragging="draggable2-piano"
                defaultClassNameDragged="draggable3-color"
            >
                <div
                    id="window-pioano"
                    className={classes.draggableWindow}
                    ref={windowRef}
                    style={{
                        width: windowResolution.width,
                        height: windowResolution.height,
                        resize: 'both',
                        overflowY: 'hidden'
                    }}>
                    <div
                        className={classes.draggableTop}
                        style={{
                            width: "100%",
                            height: '14px',
                            backgroundColor: '#E2E6E9',
                            minHeight: '15px',
                            alignItems: 'center',
                            position: 'absolute',
                            top: '0'
                        }}
                    >
                        <strong className={clsx(classes.draggableTopHandle, 'justify-center')}>
                            <svg width="30" height="10" viewBox="0 0 15 3" xmlns="http://www.w3.org/2000/svg">
                                {svgIcons.dots}
                            </svg>
                        </strong>
                        <IconButton
                            className={classes.windowButton}
                            style={{
                                display: 'flex',
                                color: props.inkColor,
                            }}
                            onClick={handleClose}>
                            <img src='/closeIcon.svg' alt='Close Icon' className='cIcon m2px' />
                        </IconButton>
                    </div>

                    <div style={{ width: "fit-content", height: "fit-content", display: "flex", marginTop: '20px', alignItems: 'center', overflow: 'auto' }}>
                        {openAccept ? (
                            <>
                                <Button onClick={accept}
                                    className={clsx(classes.greenButton, 'newbtnStyle')}
                                >
                                    <CallIcon style={{ marginRight: '8px' }} />
                      Accept
                  </Button>
                                <Button onClick={handleClose}
                                    className={clsx(classes.redButton, 'newbtnStyle')}

                                >
                                    <CallEndIcon style={{ marginRight: '8px' }} />
                      Deny
                  </Button>
                            </>
                        ):

                        <video id="videoOut">Video stream not available.</video>
                        }

                    </div>
                </div>

            </Draggable>
        </div >
    )
}